<div class="full-page-container">
  <div class="header-container">
    <h4 class="page-title">{{ 'ALARMS_MANAGEMENT.TITLE' | translate }}</h4>
    <div class="alarms-status" *ngIf="(activeAlarmsCount$ | async) as count">
      <span class="status-dot" [class.has-alarms]="count > 0"></span>
      <span class="status-text">
        {{ count > 0 ? (count + ' Active Alarms') : 'No Active Alarms' }}
      </span>
    </div>
    <div class="header-actions">
      <!-- Refresh Button -->
      <button class="refresh-btn" (click)="refresh()"
              [matTooltip]="'ALARMS_MANAGEMENT.REFRESH' | translate"
              matTooltipClass="sidebar-tooltip">
        <mat-icon>refresh</mat-icon>
        <span>{{ 'ALARMS_MANAGEMENT.REFRESH' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Control Panel -->
<!--  <div class="control-panel">-->
<!--    &lt;!&ndash; Create Alarm Form &ndash;&gt;-->
<!--    <div class="form-section">-->
<!--      <h6>{{ 'ALARMS_MANAGEMENT.CREATE_ALARM' | translate }}</h6>-->
<!--      <form [formGroup]="createAlarmForm" (ngSubmit)="onCreateAlarm()" class="form-row">-->
<!--        <mat-form-field appearance="outline">-->
<!--          <mat-label>Location ID</mat-label>-->
<!--          <input matInput formControlName="locationId" placeholder="Enter location ID" required>-->
<!--        </mat-form-field>-->

<!--        <mat-form-field appearance="outline">-->
<!--          <mat-label>Uniform ID (Optional)</mat-label>-->
<!--          <input matInput formControlName="uniformId" placeholder="Enter uniform ID">-->
<!--        </mat-form-field>-->

<!--        <button mat-raised-button color="primary" type="submit"-->
<!--                [disabled]="createAlarmForm.invalid">-->
<!--          <mat-icon>add_alert</mat-icon>-->
<!--          Create Alarm-->
<!--        </button>-->
<!--      </form>-->
<!--    </div>-->
<!--  </div>-->

  <!-- Active Alarms Section -->
  <div class="alarms-section">
    <h5>{{ 'ALARMS_MANAGEMENT.ACTIVE_ALARMS' | translate }}</h5>
    <div class="table-container">
      <ng-container *ngIf="(activeAlarms$ | async) as activeList">
        <div class="table-scroll-container" *ngIf="activeList?.length > 0; else noActiveAlarmsContent">
          <!-- Fixed Header Table -->
          <div class="table-header">
            <table>
              <thead>
              <tr class="header">
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.ALARM_ID' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.LOCATION_NAME' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.DISPATCH_TIME' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.STATUS' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.ACTIONS' | translate }}</th>
              </tr>
              </thead>
            </table>
          </div>

          <!-- Scrollable Body with Virtual Scroll -->
          <div class="table-body">
            <cdk-virtual-scroll-viewport itemSize="56">
              <table>
                <tbody>
                <tr *cdkVirtualFor="let alarm of activeList" class="table-row">
                  <td class="alarm-id">{{ alarm.id }}</td>
                  <td>{{ locationName$(alarm.locationId) | async }}</td>
                  <td>
                    <ui-user-settings-date [date]="alarm.dispatchTime"></ui-user-settings-date>
                  </td>

                  <td>
                    <span class="status-badge" [class]="getStatusClass(alarm.status)">
                      {{ getStatusText(alarm.status) }}
                    </span>
                  </td>
                  <td>
                    <mat-icon class="c-p action-icon"
                              [matTooltip]="'ALARMS_MANAGEMENT.CANCEL_ALARM' | translate"
                              (click)="cancelAlarmById(alarm.id)">
                      cancel
                    </mat-icon>
                  </td>
                </tr>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Canceled Alarms Section -->
  <div class="alarms-section">
    <h5>{{ 'ALARMS_MANAGEMENT.CANCELED_ALARMS' | translate }}</h5>
    <div class="table-container">
      <ng-container *ngIf="(canceledAlarms$ | async) as canceledList">
        <div class="table-scroll-container" *ngIf="canceledList?.length > 0; else noCanceledAlarmsContent">
          <!-- Fixed Header Table -->
          <div class="table-header">
            <table>
              <thead>
              <tr class="header">
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.ALARM_ID' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.LOCATION_NAME' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.DISPATCH_TIME' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.CANCEL_TIME' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.DISPATCH' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.CANCELED_BY' | translate }}</th>
                <th>{{ 'ALARMS_MANAGEMENT.TABLE.STATUS' | translate }}</th>
              </tr>
              </thead>
            </table>
          </div>

          <!-- Scrollable Body with Virtual Scroll -->
          <div class="table-body">
            <cdk-virtual-scroll-viewport itemSize="56">
              <table>
                <tbody>
                <tr *cdkVirtualFor="let alarm of canceledList" class="table-row">
                  <td class="alarm-id">{{ alarm.id }}</td>
                  <td>{{ locationName$(alarm.locationId) | async }}</td>
                  <td>
                    <ui-user-settings-date [date]="alarm.dispatchTime"></ui-user-settings-date>
                  </td>
                  <td>
                    <ui-user-settings-date [date]="alarm.cancelTime" *ngIf="alarm.cancelTime"></ui-user-settings-date>
                  </td>
                  <td class="duration">{{ getTimeDuration(alarm.dispatchTime, alarm.cancelTime) }}</td>
                  <td>{{ alarm.cancelBy || 'Unknown' }}</td>
                  <td>
                    <span class="status-badge" [class]="getStatusClass(alarm.status)">
                      {{ getStatusText(alarm.status) }}
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- No Content Templates -->
<ng-template #noActiveAlarmsContent>
  <div class="no-content">
    <mat-icon>check_circle</mat-icon>
    <h6>{{ 'ALARMS_MANAGEMENT.NO_ACTIVE_ALARMS' | translate }}</h6>
    <p>{{ 'ALARMS_MANAGEMENT.NO_ACTIVE_ALARMS_DESC' | translate }}</p>
  </div>
</ng-template>

<ng-template #noCanceledAlarmsContent>
  <div class="no-content">
    <mat-icon>history</mat-icon>
    <h6>{{ 'ALARMS_MANAGEMENT.NO_CANCELED_ALARMS' | translate }}</h6>
    <p>{{ 'ALARMS_MANAGEMENT.NO_CANCELED_ALARMS_DESC' | translate }}</p>
  </div>
</ng-template>
